<script setup>
import GenerationProgress from '@/components/GenerationProgress.vue'
import { useStoryblokStore } from '@/stores/storyblok'

const storyblokStore = useStoryblokStore()
</script>

<template>
  <GenerationProgress v-if="storyblokStore.progress"></GenerationProgress>
  <template v-else>
    <h2 class="text-primary text-3xl mb-8">Summary</h2>
    <div class="">
      <dl class="divide-y divide-gray-100">
        <div class="px-4 py-4 sm:grid grid-cols-[200px_1fr_1fr_1fr] sm:gap-4 sm:px-0">
          <dt class="text-sm/6 font-medium text-gray-900">Site</dt>
          <dd class="mt-1 text-sm/6 text-gray-700 sm:col-span-3 sm:mt-0">
            {{ storyblokStore.siteSlug }}
          </dd>
        </div>
        <div class="px-4 py-4 sm:grid grid-cols-[200px_1fr_1fr_1fr] sm:gap-4 sm:px-0">
          <dt class="text-sm/6 font-medium text-gray-900">Space</dt>
          <dd class="mt-1 text-sm/6 text-gray-700 sm:col-span-3 sm:mt-0">
            {{ storyblokStore.space.name }}
          </dd>
        </div>
        <div class="px-4 py-4 sm:grid grid-cols-[200px_1fr_1fr_1fr] sm:gap-4 sm:px-0">
          <dt class="text-sm/6 font-medium text-gray-900">Company</dt>
          <dd class="mt-1 text-sm/6 text-gray-700 sm:col-span-3 sm:mt-0">
            {{ storyblokStore.company.name }}
          </dd>
        </div>
        <div class="px-4 py-4 sm:grid grid-cols-[200px_1fr_1fr_1fr] sm:gap-4 sm:px-0">
          <dt class="text-sm/6 font-medium text-gray-900">Pages</dt>
          <dd class="mt-1 text-sm/6 text-gray-700 sm:col-span-3 sm:mt-0">
            <ul class="list-disc grid sm:grid-cols-2 sm:ml-4">
              <li v-for="(page, index) in storyblokStore.pages" :key="index">
                {{ page }}
              </li>
            </ul>
          </dd>
        </div>
        <div class="px-4 py-4 sm:grid grid-cols-[200px_1fr_1fr_1fr] sm:gap-4 sm:px-0">
          <dt class="text-sm/6 font-medium text-gray-900">Hero template</dt>
          <dd class="mt-1 text-sm/6 text-gray-700 sm:col-span-3 sm:mt-0">
            {{ storyblokStore.heroBannerTemplate }}
          </dd>
        </div>
        <div class="px-4 py-4 sm:grid grid-cols-[200px_1fr_1fr_1fr] sm:gap-4 sm:px-0">
          <dt class="text-sm/6 font-medium text-gray-900">Testimonials template</dt>
          <dd class="mt-1 text-sm/6 text-gray-700 sm:col-span-3 sm:mt-0">
            {{ storyblokStore.testimonialsTemplate }}
          </dd>
        </div>
      </dl>
    </div>
  </template>
</template>
